import { DEAL_ACTION_TYPE } from '../actions/deal.actions';

const initialState = {};

const dealReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DEAL_ACTION_TYPE.GET_DEAL_DATA:
    case DEAL_ACTION_TYPE.SET_DEAL_DATA:
      return payload || state;

    case DEAL_ACTION_TYPE.RESET_DEAL_DATA:
      return initialState;

    default:
      return state;
  }
};

export default dealReducer;
